import { ContentReference } from '@ilteducation/content-collections-types';
import useReservedCollection from './use-reserved-collection';
import { computed, Ref } from 'vue';

export type FavouritesParams = {
  context: string;
};

const useFavourites = (params: Ref<FavouritesParams>) => {
  const reservedCollectionParams = computed(() => ({
    collectionId: `favourites:${params.value.context}`,
    name: 'Favourites',
    icon: 'favorite',
    context: params.value.context,
  }));
  const { collection, isLoading, hasContent, addContents, removeContents } =
    useReservedCollection(reservedCollectionParams);

  const toggle = (contentReference: ContentReference): Promise<void> => {
    if (hasContent.value(contentReference)) {
      return removeContents([contentReference]);
    }
    return addContents([contentReference]);
  };

  return {
    collection,
    isLoading,
    hasContent,
    toggle,
    addContents,
    removeContents,
  };
};

export default useFavourites;
